import type { RouteLocationNormalized } from 'vue-router'
import { useProjectStore } from '@/stores/project'

function routeParamProjectId(raw: string | string[] | undefined): string | null {
  if (typeof raw === 'string') return raw
  if (Array.isArray(raw) && raw[0]) return raw[0]
  return null
}

/** Read `:projectId` from a resolved route (for guards / `afterEach`). */
export function routeParamProjectIdFromRoute(to: Pick<RouteLocationNormalized, 'params'>): string | null {
  return routeParamProjectId(to.params.projectId)
}

/**
 * Align project store with the URL’s `projectId` param. Safe to call from `router.afterEach`.
 * Uses the same rule as `setActiveProject(id, undefined, rowFromList)` in `useProjectSidebarContext`.
 */
export function syncCurrentProjectWithRouteParam(projectId: string | null) {
  const projectStore = useProjectStore()
  if (!projectId) {
    projectStore.clearCurrentProject()
    return
  }
  if (projectStore.currentProjectId === projectId && projectStore.currentProject?.name) {
    return
  }
  const list = Array.isArray(projectStore.projects) ? projectStore.projects : []
  const fromList = list.find((p) => p.id === projectId) ?? null
  projectStore.setCurrentProject(projectId, fromList)
}
